import {
  BookOpenIcon,
  CameraIcon,
  ClapperboardIcon,
  MusicIcon as DefaultIcon,
  DumbbellIcon,
  GamepadIcon,
  MicIcon,
  MonitorIcon,
  MusicIcon,
  TicketIcon,
  TreesIcon,
  TrophyIcon,
  WavesIcon,
} from 'lucide-react';

import {
  ENTERTAINMENT_CONFIG,
  ENTERTAINMENT_KEYWORDS,
  VALID_ENTERTAINMENT_SUBCATEGORIES,
  detectEntertainmentSubcategory,
  detectEntertainmentSubcategoryWithConfidence,
} from '@splitfiesta/core';

export {
  ENTERTAINMENT_CONFIG,
  ENTERTAINMENT_KEYWORDS,
  VALID_ENTERTAINMENT_SUBCATEGORIES,
  detectEntertainmentSubcategory,
  detectEntertainmentSubcategoryWithConfidence,
};

type EntertainmentIcon = React.ComponentType<{ className?: string }>;

export const ENTERTAINMENT_SUBCATEGORY_ICONS: Record<
  string,
  EntertainmentIcon
> = {
  music: MusicIcon,
  streaming: MonitorIcon,
  gaming: GamepadIcon,
  books: BookOpenIcon,
  fitness: DumbbellIcon,
  events: TicketIcon,
  sports: TrophyIcon,
  photography: CameraIcon,
  podcasts: MicIcon,
  outdoor: TreesIcon,
  water: WavesIcon,
  movies: ClapperboardIcon,
  default: DefaultIcon,
};

export function getEntertainmentIcon(
  subcategory: string | null | undefined
): EntertainmentIcon {
  if (!subcategory || !(subcategory in ENTERTAINMENT_SUBCATEGORY_ICONS)) {
    return ENTERTAINMENT_SUBCATEGORY_ICONS.default;
  }
  return ENTERTAINMENT_SUBCATEGORY_ICONS[subcategory];
}
